import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowRight16 } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import {
  PopupMenuButton,
  PopupMenuList,
  PopupMenuListItem,
} from 'shared/components/ui/popup-menu';

import { MenuGroups, SubMenu } from './types';

export type MoveListProps = {
  openSubMenu: (subMenu: SubMenu) => void;
  registerItem?: (
    group: MenuGroups,
    index: number,
    element: HTMLButtonElement | null,
  ) => void;
  registerGroup?: MenuGroups;
};

export const MoveList: React.FC<MoveListProps> = ({
  openSubMenu,
  registerItem,
  registerGroup,
}) => {
  const { t } = useTranslation();

  const onMoveGoal = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      openSubMenu(SubMenu.MoveGoal);
    },
    [openSubMenu],
  );

  return (
    <PopupMenuList hasBottomBorder>
      <PopupMenuListItem>
        <PopupMenuButton
          onClick={onMoveGoal}
          start={<Icon icon={ArrowRight16} />}
          ref={(el) => registerGroup && registerItem?.(registerGroup, 0, el)}
        >
          {t('context-menus.goal.labels.move-goal')}
        </PopupMenuButton>
      </PopupMenuListItem>
    </PopupMenuList>
  );
};
